import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Icon from '../../components/icons.jsx'
import { updateCrmContact, updateDeal, getCompanies, createCompany } from '../../db/api.js'

const demo = import.meta.env.DEV && import.meta.env.MODE === 'demo'
export default function ChatIdentityEditor({ mode, deal, leadId, onClose, onSaved }) {
  const [name, setName] = useState(mode === 'lead' ? deal.primary_lead || '' : '')
  const [companies, setCompanies] = useState([])
  const [selected, setSelected] = useState('')
  const [create, setCreate] = useState(false)
  const [loading, setLoading] = useState(mode === 'company')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  useEffect(() => {
    if (mode !== 'company' || create) return
    let alive = true
    setLoading(true)
    const timer = setTimeout(() => {
      ;(demo ? import('../../demo/data.js').then((m) => m.getDemoCompanies()) : getCompanies(name)).then((rows) => { if (alive) setCompanies(rows) })
        .catch((e) => { if (alive) setError(e.message) }).finally(() => { if (alive) setLoading(false) })
    }, name ? 250 : 0)
    return () => { alive = false; clearTimeout(timer) }
  }, [mode, name, create])
  const normalized = (value) => value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
  const filtered = demo ? companies.filter((item) => normalized(item.nome).includes(normalized(name))) : companies
  const save = async (event) => {
    event.preventDefault()
    if (saving) return
    setSaving(true); setError('')
    try {
      if (mode === 'lead') {
        if (!name.trim() || !leadId) throw new Error('Informe o nome de um contato vinculado.')
        if (demo) (await import('../../demo/data.js')).saveDemoLeadName(deal.id, name.trim())
        else await updateCrmContact(leadId, { nome: name.trim() })
        onSaved({ primary_lead: name.trim() })
      } else {
        if (create ? !name.trim() : !selected) throw new Error('Selecione uma empresa ou preencha o nome da nova empresa.')
        let company
        if (demo) {
          const payload = create ? { nome: name.trim() } : { company_id: selected }
          company = (await import('../../demo/data.js')).saveDemoCompany(deal.id, payload)
        } else {
          company = create ? await createCompany({ nome: name.trim() }) : companies.find((item) => item.id === selected)
          if (!company) throw new Error('Empresa não encontrada.')
          await updateDeal(deal.id, { company_id: company.id })
        }
        onSaved({ company_id: company.id, company_name: company.nome })
      }
      onClose()
    } catch (e) { setError(e.message || 'Não foi possível salvar.') }
    finally { setSaving(false) }
  }
  return <form className="pl-chat-quick pl-chat-identity" onSubmit={save}>
    <div className="pl-chat-quick-head"><strong>{mode === 'lead' ? 'Editar nome do lead' : create ? 'Cadastrar empresa' : 'Adicionar empresa'}</strong><button type="button" aria-label="Fechar edição" onClick={onClose} disabled={saving}><Icon n="close" s={15} /></button></div>
    {mode === 'lead' ? <label>Nome do lead<input autoFocus required maxLength={200} value={name} disabled={saving} onChange={(e) => setName(e.target.value)} /></label> : <>
      <label>{create ? 'Nome da empresa' : 'Buscar empresa'}<input autoFocus required={create} maxLength={200} value={name} disabled={saving} onChange={(e) => { setName(e.target.value); setSelected('') }} placeholder="Digite o nome…" /></label>
      {!create && <div className="pl-chat-company-results" role="group" aria-label="Empresas disponíveis">{loading ? <p>Carregando empresas…</p> : !filtered.length ? <p>Nenhuma empresa encontrada.</p> : filtered.map((company) => <button type="button" key={company.id} aria-pressed={selected === company.id} disabled={saving} onClick={() => setSelected(company.id)}>{company.nome}</button>)}</div>}
      <button type="button" className="pl-chat-company-toggle" disabled={saving} onClick={() => { setCreate(!create); setSelected(''); setError('') }}>{create ? 'Escolher empresa existente' : '+ Cadastrar nova empresa'}</button>
    </>}
    {error && <p role="alert">{error}</p>}
    <div className="pl-chat-identity-actions"><button type="submit" className="pl-chat-quick-confirm" disabled={saving || (mode === 'company' && !create && !selected)}>{saving ? 'Salvando…' : 'Salvar'}</button><button type="button" disabled={saving} onClick={onClose}>Cancelar</button>{mode === 'lead' && leadId && <Link to={`/comercial/leads/${encodeURIComponent(leadId)}`}>Ver detalhes</Link>}</div>
  </form>
}
